import hooks from './shipment-status-changes.hooks';

export default (app) => {
  const service = app.service('api/shipment-status-changes');
  service.hooks(hooks);
};
